import {
	fetchUserInquiryList,
	fetchUserInquiryDetail,
	fetchUserInquiryReplyList,
	deleteUserInquiry,
	insertUserInquiry,
	updateUserInquiry,
} from '@/api';

const namespaced = true;

const state = {
	userInquiryList: [],
	userInquiryDetail: {},
	userInquiryReplyList: [],
};

const getters = {
	userInquiryList(state) {
		return state.userInquiryList;
	},
	userInquiryDetail(state) {
		return state.userInquiryDetail;
	},
	userInquiryReplyList(state) {
		return state.userInquiryReplyList;
	},
};

const mutations = {
	getUserInquiryList(state, { page, list }) {
		if (page === undefined || list === undefined) return;

		page === 1
			? (state.userInquiryList = [...list])
			: (state.userInquiryList = [...state.userInquiryList, ...list]);
	},
	initUserInquiryList(state) {
		state.userInquiryList = [];
	},
	getUserInquiryDetail(state, { detail }) {
		state.userInquiryDetail = detail;
	},
	initUserInquiryDetail(state) {
		state.userInquiryDetail = {};
	},
	getUserInquiryReplyList(state, { list }) {
		if (list === undefined) return;

		state.userInquiryReplyList = list;
	},
	initUserInquiryReplyList(state) {
		state.userInquiryReplyList = [];
	},
};

const actions = {
	getUserInquiryList({ commit }, payload) {
		return fetchUserInquiryList(payload)
			.then(response => {
				commit('getUserInquiryList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	initUserInquiryList({ commit }) {
		commit('initUserInquiryList');
	},
	getUserInquiryDetail({ commit }, payload) {
		return fetchUserInquiryDetail(payload)
			.then(response => {
				commit('getUserInquiryDetail', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	getUserInquiryReplyList({ commit }, payload) {
		return fetchUserInquiryReplyList(payload)
			.then(response => {
				commit('getUserInquiryReplyList', response.data);
				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	deleteUserInquiry({ commit }, payload) {
		return deleteUserInquiry(payload)
			.then(response => {
				if (response.data.code === '00000') {
					commit('initUserInquiryList');
					commit('initUserInquiryDetail');
					commit('initUserInquiryReplyList');
				}

				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	insertUserInquiry({ commit }, payload) {
		return insertUserInquiry(payload)
			.then(response => {
				if (response.data.code === '00000') {
					commit('initUserInquiryList');
				}

				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
	updateUserInquiry({ commit }, payload) {
		return updateUserInquiry(payload)
			.then(response => {
				if (response.data.code === '00000') {
					commit('initUserInquiryList');
				}

				return response;
			})
			.catch(error => {
				console.log(error);
				return error;
			});
	},
};

export default {
	namespaced,
	state,
	getters,
	mutations,
	actions,
};
